<h2 mat-dialog-title>Filter Tasks</h2>
<mat-dialog-content>
  <form id="tasks-filter-form" [formGroup]="form">
    <div><mat-checkbox formControlName="showHidden"> Show hidden? </mat-checkbox></div>
    <div><mat-checkbox formControlName="showCompleted"> Show completed? </mat-checkbox></div>
    <div><mat-checkbox formControlName="showDeleted"> Show deleted? </mat-checkbox></div>

    <section formGroupName="updated">
      <mat-checkbox [checked]="enableUpdatedSince" (change)="toggleUpdatedFilter($event)"> Filter by last update? </mat-checkbox>
      <div *ngIf="enableUpdatedSince">
        <label>Since <input type="date" formControlName="since"></label>
      </div>
    </section>
    <section formGroupName="due">
      <mat-checkbox [checked]="enableDueRange" (change)="toggleDueFilter($event)"> Filter by due-date? </mat-checkbox>
      <div *ngIf="enableDueRange">
        <label>From <input type="date" formControlName="from"></label>
        <label>To <input type="date" formControlName="to"></label>
      </div>
    </section>
    <section formGroupName="completed">
      <mat-checkbox [checked]="enableCompletedRange" (change)="toggleCompletedFilter($event)"> Filter by completed-date? </mat-checkbox>
      <div *ngIf="enableCompletedRange">
        <label>From <input type="date" formControlName="from"></label>
        <label>To <input type="date" formControlName="to"></label>
      </div>
    </section>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [matDialogClose]="data">OK</button>
  <button mat-raised-button (click)="cancel()">Cancel</button>
  <button mat-raised-button (click)="reset()">Reset</button>
</mat-dialog-actions>
